import axios from 'axios';
import { HTTP_DOMAIN } from '../config';
import { notifySessionExpired } from './sessionExpiry';

export const httpClient = axios.create({
  baseURL: `${HTTP_DOMAIN}`,
  timeout: 4000,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
    accept: 'application/json'
  }
});

const isUnauthenticatedError = (error: unknown): boolean => {
  if (!axios.isAxiosError(error)) return false;

  const status = error.response?.status;
  if (status !== 401) return false;

  const responseData = error.response?.data;
  const message =
    typeof responseData === 'string'
      ? responseData
      : (responseData as { message?: string } | undefined)?.message;

  return (
    typeof message === 'string' &&
    message.toLowerCase().includes('unauthenticated')
  );
};

httpClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (isUnauthenticatedError(error)) {
      notifySessionExpired();
    }

    return Promise.reject(error);
  }
);
